import customOptionsTemplate from '../templates/customOptions.html';

// Ключ перерисовки содержимого шаблона, см. CustomOptionsCtrl.getData
const RENDER_KEY_REPEAT = 'customOptionsRenderKey in [customOptions.renderKey] track by customOptionsRenderKey';
const getAttr = (el, name) => el.getAttribute(`data-${name}`) ?? el.getAttribute(name);

/* @ngInject */
function customOptionsDirective(urlHelper) {
  return {
    scope: {
      productId: '<',
      offerId: '<',
      initFn: '&',
      changeFn: '&',
      beforeChangeFn: '&',
      customOptionPicture: '<?',
      customOptionComboView: '<?'
    },
    replace: true,
    templateUrl: customOptionsTemplate,
    controller: 'CustomOptionsCtrl',
    controllerAs: 'customOptions',
    bindToController: true,
    // При смене offerId (размер/цвет товара или позиции комбо) опции перезапрашиваются новыми объектами.
    // Под track by $index строки переиспользуются, и разметка остаётся привязанной к старым объектам:
    // - в движковом шаблоне ng-init не перевыполняется: синоним option = item.Options[0] (флажок)
    //   и начальные item.Selected / option.Selected / item.SelectedOptions остаются от старых опций;
    // - шаблоны тем, подменённые декоратором (Templates/*/scripts/_partials/custom-option), привязывают
    //   список и поля одноразово (`item in ::customOptions.items`, `::option.Title`).
    // Галочки не сбрасываются, новый выбор не попадает в расчёт. Поэтому всё содержимое шаблона,
    // каким бы он ни был, переносится в один блок, который пересоздаётся под новый ключ customOptions.renderKey.
    compile: function (tElement) {
      const root = tElement[0];
      const block = root.ownerDocument.createElement('div');
      block.className = 'custom-options-render';
      block.setAttribute('data-ng-repeat', RENDER_KEY_REPEAT);

      // ng-switch-when регистрируется в ближайшем ngSwitch один раз и не снимается при пересоздании,
      // поэтому ng-switch корня дублируется на блок — у каждого экземпляра блока свой ngSwitch
      const switchExpr = getAttr(root, 'ng-switch');
      if (switchExpr != null) {
        block.setAttribute('data-ng-switch', switchExpr);
      }
      block.append(...root.childNodes);
      root.append(block);
    }
  };
}
customOptionsDirective.$inject = ["urlHelper"];
export { customOptionsDirective };